const Socials = props => {
	const { list } = props;
	return (
		<div className="social-media center box is-shadowless no-margin-bottom">
			{Object.keys(list).map((key, index) => (
				<a
					key={index}
					href={list[key]}
					target="_blank"
					className="button is-transparent is-large">
					<i className={`fab fa-${key}`} aria-hidden="true" />
				</a>
			))}
		</div>
	);
};

export default Socials;
